import PerformanceList from '../../../components/People/Performance/PerformanceList'
import React, { Fragment } from 'react'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Row } from 'antd'

const { Content } = Layout

function Performance(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item>Our People</Breadcrumb.Item>
              <Breadcrumb.Item>Performance</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Performance'}
              subtitle={'View Performance Report for staff over task.'}
              color={'#8e44ad'}
              iconType={'area-chart'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <PerformanceList {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

export default Performance
